import { useState, useEffect } from 'react';
import API from './api';

const TOP_UP_FALLBACK = {
  story:     { id: 'story',     label: 'Story Pack',               emoji: '📖', description: '+10 stories this month',              priceDisplay: '$3.99', unitAmount: 399, grants: { stories: 10, narrations: 0, cloneNarrations: 0, regens: 0, photoIllustrations: 0 } },
  narration: { id: 'narration', label: 'Narration Pack',           emoji: '🔊', description: '+10 narrations this month',            priceDisplay: '$2.99', unitAmount: 299, grants: { stories: 0, narrations: 10, cloneNarrations: 0, regens: 0, photoIllustrations: 0 } },
  voice:     { id: 'voice',     label: 'Voice Pack',               emoji: '🎙️', description: '+5 clone narrations in your voice',   priceDisplay: '$5.99', unitAmount: 599, grants: { stories: 0, narrations: 0, cloneNarrations: 5, regens: 0, photoIllustrations: 0 } },
  regen:     { id: 'regen',     label: 'Illustration Pack',        emoji: '🎨', description: '+10 illustration regenerations',       priceDisplay: '$2.99', unitAmount: 299, grants: { stories: 0, narrations: 0, cloneNarrations: 0, regens: 10, photoIllustrations: 0 } },
  photo:     { id: 'photo',     label: 'Photo Illustration Pack',  emoji: '📸', description: '+3 face-accurate photo illustrations', priceDisplay: '$4.99', unitAmount: 499, grants: { stories: 0, narrations: 0, cloneNarrations: 0, regens: 0, photoIllustrations: 3 } },
};

const LIMITS_FALLBACK = {
  free:   { stories: 5,   narrations: 0,  cloneNarrations: 0, regens: 0,  photoIllustrations: 0 },
  basic:  { stories: 60,  narrations: 30, cloneNarrations: 0, regens: 20, photoIllustrations: 3 },
  family: { stories: 120, narrations: 40, cloneNarrations: 5, regens: 40, photoIllustrations: 6 },
};

// Basic: $20/mo · Annual: $220/yr (11 months)
// Family: $35/mo · Annual: $385/yr (11 months)
const USD_FALLBACK = {
  currency: 'USD', currencyCode: 'usd', symbol: '$',
  basic: 20, family: 35, gift: 7.99,
  basicAnnual: 220, familyAnnual: 385,
  basicUnit: 2000, familyUnit: 3500, giftUnit: 799,
  basicAnnualUnit: 22000, familyAnnualUnit: 38500,
  formatted: {
    basic: '$20', family: '$35', gift: '$7.99',
    basicAnnual: '$220', familyAnnual: '$385',
    basicMonthlyEquiv: '$18.33', familyMonthlyEquiv: '$32.08',
  },
  topUpPacks:    TOP_UP_FALLBACK,
  monthlyLimits: LIMITS_FALLBACK,
  trial:         { enabled: true, days: 7, plans: ['basic', 'family'], requiresCard: true },
};

const usePricing = () => {
  const [pricing, setPricing] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/subscriptions/pricing', { params: { _: Date.now() } })
      .then(res => {
        setPricing({
          ...res.data,
          topUpPacks:    res.data.topUpPacks    || TOP_UP_FALLBACK,
          monthlyLimits: res.data.monthlyLimits || LIMITS_FALLBACK,
          trial:         res.data.trial         || USD_FALLBACK.trial,
        });
      })
      .catch(() => setPricing(USD_FALLBACK))
      .finally(() => setLoading(false));
  }, []);

  return { pricing: pricing || USD_FALLBACK, loading };
};

export default usePricing;
